import { useTranslation } from 'react-i18next';
import SelectField from 'components/forms/selectField/SelectField';
import { BookingDotComCheckInMethodHow } from 'models/bookingDotCom/CheckInMethods';
import { orderBy } from 'utils/arrayUtils';

interface CheckInMethodHowFieldProps {
  name: 'alternativeCheckInMethod' | 'primaryCheckInMethod';
}

const CHECK_IN_METHOD_HOW_ORDER = [
  BookingDotComCheckInMethodHow.PHONE,
  BookingDotComCheckInMethodHow.EMAIL,
  BookingDotComCheckInMethodHow.SMS,
  BookingDotComCheckInMethodHow.OTHER,
];

const CheckInMethodHowField = ({ name }: CheckInMethodHowFieldProps) => {
  const { t } = useTranslation();

  const sortedCheckInMethodHowValues = orderBy(
    Object.values(BookingDotComCheckInMethodHow),
    [
      {
        field: (value) => CHECK_IN_METHOD_HOW_ORDER.indexOf(value),
        order: 'asc',
      },
    ],
  );

  const checkInMethodHowOptions = [
    { label: t('common.select'), value: '' },
    ...sortedCheckInMethodHowValues.map((value) => ({
      label: t(
        `pageProperty.mainSettings.bookingDotComSettings.checkInMethodHow.${value}`,
      ),
      value,
    })),
  ];

  return (
    <SelectField
      label={`${t(
        `pageProperty.mainSettings.bookingDotComSettings.${name}.how`,
      )}:`}
      name={`bookingDotComSettings.${name}.how`}
      options={checkInMethodHowOptions}
      colSmInput={12}
      colSmLabel={12}
      labelOnTop
    />
  );
};

export default CheckInMethodHowField;
